import React, { useEffect, useRef } from 'react';
import { FormError } from '@typings/common';

interface NewErrorSummaryProps {
  errors: FormError[];
}

const NewErrorSummary: React.FC<NewErrorSummaryProps> = ({ errors }) => {
  const errorSummaryRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    // eslint-disable-next-line react/prop-types
    if (errors.length > 0 && errorSummaryRef.current) {
      errorSummaryRef.current.focus();
    }
  }, [errors]);

  return (
    <div
      className="govuk-error-summary"
      data-module="govuk-error-summary"
      ref={errorSummaryRef}
      tabIndex={-1}
    >
      <div role="alert">
        <h2 className="govuk-error-summary__title">There is a problem</h2>
        <div className="govuk-error-summary__body">
          <ul className="govuk-list govuk-error-summary__list">
            {errors.map(error => (
              <li key={error.id}>
                <a href={`#${error.id}`}>{error.message}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NewErrorSummary;
